import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BreadCumb, DataTables, NavBar, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from "jquery";
import moment from "moment";

let apiClient = ApiClient.getInstance();

const headersDataTable = [ // Si se modifica el orden o activo de estos revisar como impacta a la vista de OPRQ
    { title: "Doc. orígen", value: true },//0
    // {title: "Nota creador", value: true},//
    { title: "Nota autorizador", value: true },//1
    { title: "Cliente", value: true },//2
    { title: "Nombre", value: true },//3
    { title: "Total", value: true },//4
    { title: "Fecha Cont.", value: true },//5
    { title: "Tiempo de fabricación", value: true },//6
    { title: "Fecha de producción", value: true },//7
    { title: "Tiempo", value: true },//8
    { title: "ID documento", value: true },//9
]

class BillingBorradorView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liFacturaBorrador");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    selectValidateSeries = (table, data, docSubType) => {
        let series = "";

        switch (table) {
            case '23':
                series = data.U_FMB_ValidateSeriesOQUT || "";
                break;
            case '17':
                series = data.U_FMB_ValidateSeriesORDR || "";
                break;
            case '15':
                series = data.U_FMB_ValidateSeriesODLN || "";
                break;
            case '13':
                if (docSubType === "--") {
                    series = data.U_FMB_ValidateSeriesOINV || "";
                } else {
                    series = data.U_FMB_ValidateSeriesDN || "";
                }
                break;
            case '203':
                series = data.U_FMB_ValidateSeriesODPI || "";
                break;
            case '16':
                series = data.U_FMB_ValidateSeriesORDN || "";
                break;
            case '18':
                series = data.U_FMB_ValidateSeriesOPCH || "";
                break;
            case '24':
                series = data.U_FMB_ValidateSeriesORCT || "";
                break;
            case '21':
                series = data.U_FMB_ValidateSeriesORPD || "";
                break;
            case '67':
                series = data.U_FMB_ValidateSeriesOWTR || "";
                break;
            case '14':
                series = data.U_FMB_ValidateSeriesORIN || "";
                break;
            case '1250000001':
                series = data.U_FMB_ValidateSeriesOWTQ || "";
                break;
            case '59':
                series = data.U_FMB_ValidateSeriesOIGN || "";
                break;
            case '60':
                series = data.U_FMB_ValidateSeriesOIGE || "";
                break;
            case '22':
                series = data.U_FMB_ValidateSeriesOPOR || "";
                break;
            case '204':
                series = data.U_FMB_ValidateSeriesODPO || "";
                break;
            case '20':
                series = data.U_FMB_ValidateSeriesOPDN || "";
                break;

            case '1470000113':
                series = data.U_FMB_ValidateSeriesOPRQ || "";
                break;
            case '162':
                series = data.U_FMB_ValidateSeriesOMRV || "";
                break;
            default:
                series = "";
        }

        return { series }
    };


    callDocumentsListService = async newDate => {

        let docType = $('#selectDocTypeDocumentSearch').val();
        let docType2 = $('#selectDocTypeDocumentStockValidator').val();

        let isInvoice = false;
        let isdebitNote = "--";

        if (docType === '13' || docType === '13DN') {
            isInvoice = true;
        }

        if (docType === '13DN') {
            isdebitNote = "DN";
            docType = '13'
        }

        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            docSubType: isdebitNote,
            docSubTypeDraft: docType,
            table: "ODRF",
            authorizedFilter: docType2,
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            // groupCodeValue: 'true'// comentar para subir y
        };

        let invoiceListResponse;
        enableSpinner(true);
        if (isInvoice) {
            invoiceListResponse = await apiClient.getDocumentsListInvoice(data);
        } else {
            invoiceListResponse = await apiClient.getDocumentsList(data);
        }
        enableSpinner(false);
        if (invoiceListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            let dataSerie = {
                docType: docType,
                docSubType: isdebitNote
            };

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = this.selectValidateSeries(docType, user, isdebitNote);

            if (!user || ValidateSeries.series === "") {
                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.series.split("|");


            let newArraySeries = [];

            for (let index = 0; index < seriesUsers.length; index++) {
                const serieUser = seriesUsers[index];
                for (let index = 0; index < seriesResponse.data.length; index++) {
                    const serieResponse = seriesResponse.data[index];
                    if (isInvoice) {
                        if (Number(serieResponse.Series) === Number(serieUser) && Number(serieResponse.ObjectCode) === 13 && serieResponse.DocSubType === '--' && !newArraySeries.some(item => String(item.Series) === String(serieResponse.Series))) {
                            newArraySeries.push(serieResponse);
                        }
                    } else {
                        if (Number(serieResponse.Series) === Number(serieUser) && !newArraySeries.some(item => String(item.Series) === String(serieResponse.Series))) {
                            newArraySeries.push(serieResponse);
                        }
                    }
                }
            }

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }



            let newDocumentsfilterSeries = [];

            for (let index = 0; index < invoiceListResponse.data.length; index++) {
                const document = invoiceListResponse.data[index];
                const alreadyAdded = newDocumentsfilterSeries.some(doc => doc.DocEntry === document.DocEntry);
                if (!alreadyAdded) {
                for (let index = 0; index < newArraySeries.length; index++) {
                    const serie = newArraySeries[index];
                    if (Number(document.SeriesCode) === Number(serie.Series)) {
                        newDocumentsfilterSeries.push(document);
                        break;
                      }
                    }
                }
            }

            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        } else {
            this.setState({
                data: [],
            });
        }

        //  showAlert({type: 'error', message: invoiceListResponse.message});

    }


    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    render() {
        const { headers, data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'DOCUMENTOS AUTORIZADOS PENDIENTES'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <span id="linkOrdProv" className="text-muted">
                            &nbsp;DOCUMENTOS AUTORIZADOS PENDIENTES
                        </span>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"invoiceBorrador"}
                        data={data}
                        search={this.searchDocuments}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillingBorradorView);


